import * as z from 'zod';

import { WorkoutPlanId } from '../../../BrandedIds';
import { ForbearanceCancellationReason } from '../../../loan/WorkoutPlan';
import { BaseLoanEvent } from '../../BaseLoanEvent';

export const ScheduleForbearanceWorkoutPlanCancellationEvent = BaseLoanEvent.extend({
  type: z.literal('scheduleForbearanceWorkoutPlanCancellation'),
  workoutPlanId: WorkoutPlanId,
  reason: ForbearanceCancellationReason,
  terminationDate: z.date(),
});
export type ScheduleForbearanceWorkoutPlanCancellationEvent = z.infer<
  typeof ScheduleForbearanceWorkoutPlanCancellationEvent
>;
